module.exports = __webpack_public_path__ + "static/media/fileicon_black_orange.99ed17b0.svg";